const PREFIX = '[Course]';

export const ADD_PAGE = `${PREFIX} ADD PAGE`;
export const ADD_PAGE_CREATE = `${PREFIX} ADD PAGE CREATE`;
export const DELETE_PAGE = `${PREFIX} DELETE PAGE`;
export const REORDER_PAGES = `${PREFIX} REORDER PAGES`;
export const SET_ACTIVE_PAGE_ID = `${PREFIX} SET ACTIVE PAGE ID`;
export const SET_ACTIVE_SLIDE_ID = `${PREFIX} SET ACTIVE SLIDE ID`;
export const SET_PAGE_DATA = `${PREFIX} UPDATE PAGE DATA`;
export const SET_SLIDE_DATA = `${PREFIX} UPDATE SLIDE DATA`;
export const PATCH_SPEED_COURSE_SETTINGS = `${PREFIX} UPDATE SPEED COURSE SETTINGS`;
export const SWITCH_SPEED_COURSE = `${PREFIX} ENABLE SPEED COURSE`;
export const TOGGLE_SETTINGS = `${PREFIX} TOGGLE SETTINGS`;
export const SCENE_START_PREVIEW = `${PREFIX} SCENE START PREVIEW`;
export const SCENE_END_PREVIEW = `${PREFIX} SCENE END PREVIEW`;
export const DUPLICATE_PAGE = `${PREFIX} DUPLICATE PAGE`;

export const SET_COURSE_PAGE = `${PREFIX} SET COURSE PAGE`;
export const gotoPage = (payload = {}) => ({
  type: SET_COURSE_PAGE,
  payload,
});

export const sceneStartPreview = () => ({type: SCENE_START_PREVIEW});

export const sceneEndPreview = () => ({type: SCENE_END_PREVIEW});

export const toggleSettings = () => ({type: TOGGLE_SETTINGS});

export const addPage = (payload = {}) => ({
  type: ADD_PAGE,
  payload,
});

export const addPageCreate = (payload = {}) => ({
  type: ADD_PAGE_CREATE,
  payload,
});

export const deletePage = payload => ({
  type: DELETE_PAGE,
  payload,
});

export const duplicatePage = payload => ({
  type: DUPLICATE_PAGE,
  payload,
});

export const reorderPages = (payload = []) => ({
  type: REORDER_PAGES,
  payload,
});

export const setActiveSlideId = payload => ({
  type: SET_ACTIVE_SLIDE_ID,
  payload,
});

export const setActivePageId = payload => ({
  type: SET_ACTIVE_PAGE_ID,
  payload,
});

export const SET_ACTIVE_ELEMENT_ID = `${PREFIX} SET ACTIVE ELEMENT ID`;
export const setActiveElementId = payload => ({
  type: SET_ACTIVE_ELEMENT_ID,
  payload,
});

export const updatePageData = payload => ({
  type: SET_PAGE_DATA,
  payload,
});

export const updateSlideData = payload => ({
  type: SET_SLIDE_DATA,
  payload,
});

export const INIT_AI_UPDATE = `${PREFIX} INIT AI UPDATE`;

export const initAIUpdate = payload => ({
  type: INIT_AI_UPDATE,
  payload,
});

export const SET_LOADING = `${PREFIX} SET LOADING`;

export const setLoading = ({id, isLoading = true}) => ({
  type: SET_LOADING,
  payload: {
    id,
    isLoading,
  },
});

export const patchSpeedCourseSettings = payload => ({
  type: PATCH_SPEED_COURSE_SETTINGS,
  payload,
});

export const switchSpeedCourse = () => ({type: SWITCH_SPEED_COURSE});

export const FETCH_COURSE_DATA = `${PREFIX} FETCH COURSE DATA`;
export const FETCH_COURSE_DATA_REQUEST = `${PREFIX} FETCH COURSE DATA REQUEST`;
export const FETCH_COURSE_DATA_SUCCESS = `${PREFIX} FETCH COURSE DATA SUCCESS`;
export const FETCH_COURSE_DATA_FAILURE = `${PREFIX} FETCH COURSE DATA FAILURE`;

export const fetchCourseData = () => ({type: FETCH_COURSE_DATA});

export const fetchCourseDataRequest = () => ({type: FETCH_COURSE_DATA_REQUEST});
export const fetchCourseDataSuccess = payload => ({
  type: FETCH_COURSE_DATA_SUCCESS,
  payload,
});
export const fetchCourseDataFailure = () => ({type: FETCH_COURSE_DATA_FAILURE});

export const SAVE_COURSE_DATA = `${PREFIX} SAVE COURSE DATA`;
export const SAVE_COURSE_DATA_REQUEST = `${PREFIX} SAVE COURSE DATA REQUEST`;
export const SAVE_COURSE_DATA_SUCCESS = `${PREFIX} SAVE COURSE DATA SUCCESS`;
export const SAVE_COURSE_DATA_FAILURE = `${PREFIX} SAVE COURSE DATA FAILURE`;

export const saveCourseData = payload => ({type: SAVE_COURSE_DATA, payload});

export const saveCourseDataRequest = () => ({type: SAVE_COURSE_DATA_REQUEST});

export const saveCourseDataSuccess = () => ({type: SAVE_COURSE_DATA_SUCCESS});

export const saveCourseDataFailure = () => ({type: SAVE_COURSE_DATA_FAILURE});

export const THUMBNAIL_GENERATED = `${PREFIX} THUMBNAIL GENERATED`;

export const thumbnailGenerated = payload => ({type: THUMBNAIL_GENERATED, payload});

export const UPLOAD_CONTENT_FILE = `${PREFIX} UPLOAD CONTENT FILE`;
export const UPLOAD_CONTENT_FILE_REQUEST = `${PREFIX} UPLOAD CONTENT FILE REQUEST`;
export const UPLOAD_CONTENT_FILE_SUCCESS = `${PREFIX} UPLOAD CONTENT FILE SUCCESS`;
export const UPLOAD_CONTENT_FILE_FAILURE = `${PREFIX} UPLOAD CONTENT FILE FAILURE`;
export const DELETE_CONTENT_FILE = `${PREFIX} REMOVE CONTENT FILE`;

export const uploadContentFile = payload => ({
  type: UPLOAD_CONTENT_FILE,
  payload,
});

export const uploadContentFileRequest = () => ({type: UPLOAD_CONTENT_FILE_REQUEST});

export const uploadContentFileSuccess = payload => ({
  type: UPLOAD_CONTENT_FILE_SUCCESS,
  payload,
});

export const uploadContentFileFailure = () => ({type: UPLOAD_CONTENT_FILE_FAILURE});

export const deleteContentFile = () => ({type: DELETE_CONTENT_FILE});

export const SET_DESCRIPTION_PAGE_DATA = `${PREFIX} SET DESCRIPTION PAGE SETTINGS`;
export const SET_SETTINGS_PAGE_DATA = `${PREFIX} SET SETTINGS PAGE SETTINGS`;
export const SET_RESULTS_PAGE_DATA = `${PREFIX} SET RESULTS PAGE SETTINGS`;

export const setSettingsPageData = payload => ({
  type: SET_SETTINGS_PAGE_DATA,
  payload,
});

export const setDescriptionPageData = payload => ({
  type: SET_DESCRIPTION_PAGE_DATA,
  payload,
});

export const setResultsPageData = payload => ({
  type: SET_RESULTS_PAGE_DATA,
  payload,
});

export const SET_SCREEN_SIZE = `${PREFIX} SET PAGE SIZE SETTINGS`;
export const setScreenSize = payload => ({
  type: SET_SCREEN_SIZE,
  payload,
});

export const ADD_ASSETS = `${PREFIX} ADD ASSETS`;
export const addAssets = payload => ({
  type: ADD_ASSETS,
  payload,
});

export const UPDATE_THUMB_REQUEST = `${PREFIX} UPDATE THUMB REQUEST`;
export const updateThumbRequest = payload => ({
  type: UPDATE_THUMB_REQUEST,
  payload,
});

export const UPDATE_THUMB_SUCCESS = `${PREFIX} UPDATE THUMB SUCCESS`;
export const updateThumbSuccess = payload => ({
  type: UPDATE_THUMB_SUCCESS,
  payload,
});

export const UPDATE_THUMB_INTERUPTED = `${PREFIX} UPDATE THUMB INTERUPTED`;
export const updateThumbInterupted = payload => ({
  type: UPDATE_THUMB_INTERUPTED,
  payload,
});


export const UPDATE_THUMBNAIL_IN_ACTIVE_PAGE = `${PREFIX} UPDATE THUMBNAIL IN ACTIVE PAGE`;
export const updateThumbnailForActivePage = payload => ({
  type: UPDATE_THUMBNAIL_IN_ACTIVE_PAGE,
  payload,
});

export const UPDATE_THUMBNAIL_IN_ALL_PAGES = `${PREFIX} UPDATE THUMBNAIL IN ALL PAGES`;
export const updateThumbnailInAllPages = payload => ({
  type: UPDATE_THUMBNAIL_IN_ALL_PAGES,
  payload,
});

export const SET_CREATE_BIT_SETUP_IS_DONE = `${PREFIX} CREATAE BIT SETUP IS DONE`;
export const setCreateBitSetupIsDone = payload => ({
  type: SET_CREATE_BIT_SETUP_IS_DONE,
  payload,
});


export const SAVE_BIT_TITLE_ANDDESCRIPTION = `${PREFIX} SAVE BIT TITLE AND DESCRIPTION`;
export const saveBitTitleAndDescription = payload => ({
  type: SAVE_BIT_TITLE_ANDDESCRIPTION,
  payload,
});

